const userMap = {
    data:{
        sessionId: '17d5547f-8864-491b-ac45-d02ce1512816',
    },
    code: '100',
    msg:"success"
}

export default {
    getUserInfo: config => {
        return userMap
    },
    logout: () => userMap,
    getMsgCode: {
        code:"100",
        msg:"success",
        data:{
            msgCode:"100"
        }
    },
    loginByCode: {
        code:"100",
        msg:"success",
        data:{
           status:0
        }
    },
    setPassword: {
        code:"100",
        msg:"success",
        data:{
        }
    }
}